import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Label, Table } from 'react-bootstrap';
import {
  Bubble,
  Pager,
  PagerPageSize,
  PagerStatusFilter,
  Divider
} from 'ctia-ui';
import ListRow from 'components/labRequest/LabListRow';
import FilterOptions from 'containers/request/TestRequestList/FilterOptions';
import { fetchRequestsForTesting, clearRequests } from 'actions/requests';
import { startPreloader, finishPreloader } from 'actions/preloader';
import {
  getTestStatusGroup
  // getTestResultTitle
} from 'helpers/RequestTestsHelper';

class TestRequestList extends Component {
  constructor(props) {
    super(props);

    this.startPage = 1;
    this.initialStatus = 'Pending';
    this.state = {
      status: this.initialStatus,
      pageSize: 100,
      statusFilter: getTestStatusGroup(this.initialStatus)
    };
  }

  componentDidMount() {
    this.getRequests(this.startPage);
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  onStatusChange = event => {
    // const newStatus = Number(event.target.value);
    const newStatus = event.target.value;
    const statusFilter = getTestStatusGroup(newStatus);

    this.setState({
      [event.target.id]: newStatus,
      statusFilter
    });

    // fetch new list
    this.getRequests(this.startPage, statusFilter);
  };

  getRequests = (
    pageNum,
    statusFilter = this.state.statusFilter,
    pageSize = this.state.pageSize
  ) => {
    const {
      startPreloader,
      fetchRequestsForTesting,
      finishPreloader
    } = this.props;

    startPreloader().then(
      fetchRequestsForTesting(pageNum, pageSize, statusFilter).then(
        finishPreloader
      )
    );
  };

  onChangePageSize = size => {
    const pageSize = Number(size);

    this.setState({ pageSize });

    // fetch new list
    this.getRequests(this.startPage, this.state.statusFilter, pageSize);
  };

  render() {
    const { requests } = this.props;

    if (_.isNull(requests) || _.isUndefined(requests.list)) {
      return null;
    }

    const tableData = requests.list;
    const {
      CURRENTPAGE: page,
      TOTALPAGES: pages,
      TOTALRECORDS: total = 0
    } = requests.pages;

    return (
      <div>
        <h1 style={{ paddingBottom: 15 }}>
          Requests for Testing{' '}
          {/* <Label>{getTestResultTitle(this.state.status)}</Label> */}
          <Label>{this.state.status}</Label>
        </h1>
        <Bubble>
          Click on the <strong>Request</strong> to view the request. You may{' '}
          <strong>sort by status type</strong>.
        </Bubble>
        <div id="request-filter">
          <Col xs={6} />
          <Col xs={2}>
            <b>Total records:</b> {total}
          </Col>
          <Col xs={2}>
            <PagerPageSize
              size={this.state.pageSize}
              onChangeHandler={this.onChangePageSize}
              options={[25, 50, 100]}
            />
          </Col>
          <Col xs={2}>
            <PagerStatusFilter
              status={this.state.status}
              statusOptions={<FilterOptions />}
              onStatusChange={this.onStatusChange}
            />
          </Col>
        </div>
        <Table striped condensed hover>
          <thead>
            <tr>
              <th>Request Id</th>
              <th>Manufacturer</th>
              <th>Model Name / Number</th>
              <th>Device Type</th>
              <th>Test Module</th>
              <th>Request Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <ListRow tableRows={tableData} />
          </tbody>
        </Table>
        <Divider show={pages > 1} />
        <Pager moveTo={this.getRequests} totalPages={pages} page={page} />
      </div>
    );
  }
}

function mapStateToProps({ requests }) {
  return { requests };
}

export default connect(
  mapStateToProps,
  {
    fetchRequestsForTesting,
    clearRequests,
    startPreloader,
    finishPreloader
  }
)(TestRequestList);



// WEBPACK FOOTER //
// ./src/containers/request/TestRequestList/index.js